export default import.meta.ROLLUP_FILE_URL_ykb1zIozoJBMq4UvQnlhcQ;